import {
  AssetProvider, AssetType, IAsset, IAssetDownload,
} from '@imcc/transport';
import { GraphicSymbolSearchHitMetadata } from './graphic-symbol-search-hit-metadata';
import { GraphicSymbolStatus } from './graphic-symbol-status';

export class GraphicSymbolSearchHit implements IAsset {
  assetType: AssetType.GraphicSymbol;

  assetName: string;

  categories: string[];

  copyright: string;

  id: string;

  isReleased: boolean;

  keywords: string[];

  name: string;

  productionYear: number;

  updatedAt: Date;

  status: GraphicSymbolStatus;

  metadata: GraphicSymbolSearchHitMetadata;

  fullName: string;

  provider: AssetProvider.Internal;

  downloads: IAssetDownload[];

  thumbnailUrl: string;

  downloadUrl: string;

  relevanceScore: number;

  fileExtension: 'zip' = 'zip';
}
